import { bikes } from './bikes.svelte';
import { cabinets } from './cabinets.svelte';
import { fleet } from './fleet.svelte';
import { sites } from './sites.svelte';
import { solarSites } from './solarSites.svelte';
import { ui } from './ui.svelte';

let refreshing = $state(false);

export const refresher = {
  get refreshing() {
    return refreshing;
  },
  /**
   * Soft refresh: re-fetch the live stores in place. Replaces the native
   * pull-to-refresh we disabled in tokens.css, so it must actually *look*
   * like it is working — hence the await. allSettled, not all: each store
   * already logs and swallows its own failure, and one rejection must not
   * skip the finally and strand the spinner on.
   *
   * B8: FleetHeader's own refresh button is gone, so the topbar's has to cover
   * the Fleet tab too — otherwise the tab would have no desktop refresh at all.
   */
  async run(): Promise<void> {
    if (refreshing) return;
    refreshing = true;
    try {
      await Promise.allSettled([
        sites.load(),
        cabinets.load(),
        ...(ui.driverHeat ? [bikes.load()] : []),
        ...(ui.tab === 'fleet' ? [fleet.refresh(), solarSites.refresh()] : []),
      ]);
    } finally {
      refreshing = false;
    }
  },
};
